import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 1.17,
  },
  chartContainer: {
    padding: '2rem 2.5rem',
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.35)',
    borderRadius: '4px',
    '& svg': { overflow: 'visible' },
  },
  chartXLabels: {
    fontSize: '0.75rem',
    marginTop: '-1rem',
    display: 'flex',
    justifyContent: 'space-between',
  },
  chartHeader: {
    display: 'flex',
    marginBottom: '1.75rem',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  link: {
    marginLeft: 'auto',
    marginRight: '1rem',
    padding: 0,
    color: theme.palette.link.main,
  },
  iconButton: {
    color: theme.palette.link.main,
    padding: 0,
  },
  chartLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    paddingBottom: '2rem',
  },
}));

const tooltipStyles = makeStyles((theme) => ({
  tooltip: {
    background: 'white',
    padding: '0.25rem 0.5rem',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.border.color,
  },
  labelDate: {
    fontWeight: 500,
  },
  labelValues: {},
}));

export { useStyles, tooltipStyles };
